"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEVEL = exports.REQ_TYPE = exports.SPAMODE = exports.PLUGIN_NAME = void 0;
var PLUGIN_NAME;
(function (PLUGIN_NAME) {
    PLUGIN_NAME["FST"] = "fst";
    PLUGIN_NAME["CACHE"] = "cache";
    PLUGIN_NAME["ERROR"] = "error";
    PLUGIN_NAME["NETWORK"] = "network";
    PLUGIN_NAME["PV"] = "pv";
    PLUGIN_NAME["RESOURCE"] = "resource";
    PLUGIN_NAME["SCROLLFPS"] = "scrollFps";
    PLUGIN_NAME["STARTUP"] = "startup";
    PLUGIN_NAME["TTI"] = "tti";
    PLUGIN_NAME["LCP"] = "lcp";
    PLUGIN_NAME["FSP"] = "fsp";
    PLUGIN_NAME["FID"] = "fid";
    PLUGIN_NAME["LONGTASK"] = "longtask";
})(PLUGIN_NAME = exports.PLUGIN_NAME || (exports.PLUGIN_NAME = {}));
var SPAMODE;
(function (SPAMODE) {
    SPAMODE["HASH"] = "hash";
    SPAMODE["HISTORY"] = "history";
    SPAMODE["NODE"] = "no";
})(SPAMODE = exports.SPAMODE || (exports.SPAMODE = {}));
var REQ_TYPE;
(function (REQ_TYPE) {
    REQ_TYPE["XHR"] = "xhr";
    REQ_TYPE["FETCH"] = "fetch";
    REQ_TYPE["CUSTOM"] = "custom";
})(REQ_TYPE = exports.REQ_TYPE || (exports.REQ_TYPE = {}));
var LEVEL;
(function (LEVEL) {
    LEVEL["ERROR"] = "error";
    LEVEL["WARN"] = "warn";
    LEVEL["INFO"] = "info";
})(LEVEL = exports.LEVEL || (exports.LEVEL = {}));
//# sourceMappingURL=index.js.map